export default __webpack_public_path__ + "static/Dacreed training partners big-be06013a894d9c3e1031cde8da068240.png";